import React from 'react'

export default function NewsItem(props) {
    
    return (
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card">
                <img class="card-img-top newsCardImage" src={props.image_url} alt={props.title} />
                <div class="card-block">
                    <h4 class="card-title m-t-0 m-b-10 newsCardTitle">
                    <a href={props.link} target="_blank" class="card-link pull-right text-inverse">{props.title}</a></h4>
                    <p class="card-text">
                        {props.showing_date}</p>
                    
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/News/NewsItem.js